export { default as useCacheUpdateQuery } from './useCacheUpdateQuery';
